


import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PasswordTextComponent extends Vue
{
	@Prop(Boolean)
	private autocomplete!: boolean;
	@Prop(Boolean)
	private disabled!: boolean;
	@Prop(String)
	private id!: string;
	@Prop(Number)
	private maxlength!: number;
	@Prop(String)
	private pattern!: string;
	@Prop(String)
	private placeholder!: string;
	@Prop(Boolean)
	private readonly!: boolean;
	@Prop(Boolean)
	private required!: boolean;
	@Prop(Number)
	private size!: number;
	@Prop(String)
	private title!: string;
	@Prop(String)
	private value!: string;

	private type: string = 'password';
	private isShowPassword: boolean = false;

	private created()
	{
		// this.id = Math.random().toString(36).slice(-8);
	}

	// パスワード表示／非表示トグル
	private onClickIcon()
	{
		this.isShowPassword = ! this.isShowPassword;
		this.type = this.isShowPassword ? 'text' : 'password';
	}

	@Emit('input')
	private emitValue(value: string) {}

	get valueModel()
	{
		return this.value;
	}

	set valueModel(value: string)
	{
		this.emitValue(value);
	}
}
